import FavoriteEmployee from "../models/FavoriteEmployee";
import FavoriteProduct from "../models/FavoriteProduct"
import CustomerProgram from "../models/CustomerProgram"
import CustomerProgramWithHistory from "../models/CustomerProgramWithHistory";
import Order from '../models/Order'
import ProductOrder from '../models/ProductOrder'
import ProductOrderDetailed from '../models/ProductOrderDetailed'
import OrderDetailed from '../models/OrderDetailed'
import FavoriteTreatment from '../models/FavoriteTreatment'
import { axiosLoader } from "@fixit/utils";
import Vue from "vue";

/**
 * Eventbus to emit error messages to parent application
 * The error events are being caught in created() in 'TheFixitNoHeader.vue'
 * and emitted to parent to be displayed as a snackbar.
**/
export let ProfileEventbus = new Vue();

async function loadModules() {
  if (process.client && window) {
    await axiosLoader();
  }
}


/**
 * IMPORTANT!!
 * Service requires the parent application using the components to have it's axios instance correctly set up.
 */
export default async function ($axios) {
  if (!$axios) {
    await loadModules();
  }
  const _axios = $axios ? $axios : window.axios ? window.axios : null;
  const ProfileSvc = {
    emitSnackbar(snackbar) {
      ProfileEventbus.$emit("snackbar", snackbar)
    },

    /**--------------------------------------- UMBRACO  ---------------------------------------------**/

    /**
     * Fetch the user's favorite employees
     *
     * @param baseUrl - axios endpoint url
     * @returns {Object}
     */
    async GetUmbraco(baseUrl) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/Home/umbraco`,
          { withCredentials: false }
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.dto
        }
      } catch (e) {

      }
      return [];
    },

    /**--------------------------------------- USER  ---------------------------------------------**/

    /**
     * Fetch the user's favorite employees
     *
     * @param baseUrl - axios endpoint url
     * @returns {Object}
     */
    async DeleteUser(baseUrl) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/my-page/delete-profile`,
        ).then(res => {
          result = res
        })
        if (result.data && (result.data.responseCode === 200 || result.data.responseCode === 203)) {
          return result.data.booleanValue
        } else return false
      } catch (e) {

      }
      return [];
    },

    /**
     * GDPR
     *
     * @param baseUrl - axios endpoint url
     * @param body - isTpn, TpnChainId
     * @returns {Object}
     */
    async GetGdprUser(baseUrl, body) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/gdpr/get-user`,
          { 
            'isTpn': body.isTpn,
            'tpnChainId': body.tpnChainId
          }
        ).then(res => {
          result = res
        })
        if (result.data && (result.data.responseCode === 200 || result.data.responseCode === 201)) {
          return result
        } else return false
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi skulle videresende til dine lagrede data. Prøv igjen senere, eller kontakt kundesenter på 55 70 70 60.', 
          visible: true, 
          duration: 10000, 
          state: 'error'
        });
      }
      return [];
    },

    /**--------------------------------------- SALONS  ---------------------------------------------**/

    /**
     * Fetch the user's salons
     *
     * @param baseUrl - axios endpoint url
     * @param currentSiteId - Current site's Id
     * @param chainIds - chainIds
     * @param forceCreate - Boolean (defaults to false if not provided)
     * @returns {Object}
     */
    async GetMySalons(baseUrl, currentSiteId, chainIds, forceCreate) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/my-page/my-salons?currentSiteId=${currentSiteId}&chainIds=${chainIds}&forceCreate=${forceCreate}`
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.chainList
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å hente dine favorittsalonger!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },
    /**
     * Fetch the user's visited salons
     *
     * @param baseUrl - axios endpoint url
     * @returns {Object}
     */
    async GetMyVisitedSalons(baseUrl) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/my-page/get-visited-chains`
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.chains
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å hente dine favorittsalonger!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Fetch salon name by site id
     *
     * @param baseUrl - axios endpoint url
     * @param siteId - int siteId
     * @returns {String}
     */
    async GetSalonNameBySiteId(baseUrl, siteId) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/my-page/my-salons/salon-name`, { params: { siteId: siteId }}
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.dto
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å hente salongdataen!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Updates the user's salons
     *
     * @param baseUrl - axios endpoint url
     * @param siteId - siteId to update
     * @param isFavorite - Boolean
     * @returns {Boolean}
     */
    async UpdateMySalons(baseUrl, siteId, isFavorite) {
      let result;
      try {
        await _axios.patch(
          baseUrl + `/api/my-page/my-salons/update`,
          { 
            'siteId': siteId,
            'isFavorite': isFavorite
          }
        ).then(res => {
          result = res
        })
        if (result) {
          ProfileEventbus.$emit("snackbar", { 
            message: 'Dine salonger er oppdatert!', 
            visible: true, 
            duration: 3000, 
            state: 'info'
          });
          return true
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å oppdatere dine favorittsalonger!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return false;
    },

    
    /**--------------------------------------- EMPLOYEES  ---------------------------------------------**/

    /**
     * Fetch the user's favorite employees
     *
     * @param baseUrl - axios endpoint url
     * @param siteIds - SiteIds to fetch employees from
     * @returns {FavoriteEmployee}
     */
    async GetFavoriteEmployees(baseUrl, siteIds) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/favorites/employees?isMobile=true`, siteIds
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.employeeList.map(emp => new FavoriteEmployee(emp));
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å hente dine favorittansatte!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Updates the user's favorite employees
     *
     * @param baseUrl - axios endpoint url
     * @param employeeId - employeeId (string)
     * @returns {Boolean}
     */
    async UpdateFavoriteEmployee(baseUrl, employeeId) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/favorites/employees/update`,
          { 
            'employeeId': employeeId,
          }
        ).then(res => {
          result = res
        })
        if (result.data) {
          ProfileEventbus.$emit("snackbar", { 
            message: 'Favorittansatte er oppdatert!', 
            visible: true, 
            duration: 3000, 
            state: 'info'
          });
          return true
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å oppdatere dine favorittansatte!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return false;
    },

    /**--------------------------------------- TREATMENTS  ---------------------------------------------**/

    /**
     * Fetch the user's favorite treatments
     *
     * @param baseUrl - axios endpoint url
     * @returns {FavoriteTreatment}
     */
    async GetFavoriteTreatments(baseUrl, siteIds) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/favorites/treatments`, siteIds
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.array.map(treatment => new FavoriteTreatment(treatment));
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å hente dine favorittbehandlinger!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Updates the user's favorite treatments
     *
     * @param baseUrl - axios endpoint url
     * @param treatmentId - treatmentId (string)
     * @param siteId - siteId
     * @returns {Boolean}
     */
    async UpdateFavoriteTreatments(baseUrl, treatmentId, siteId) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/favorites/treatments/update`,
          { 
            'treatmentId': treatmentId,
            'siteId': siteId.toString()
          }
        ).then(res => {
          result = res
        })
        if (result.data) {
          ProfileEventbus.$emit("snackbar", { 
            message: 'Behandlinger er oppdatert!', 
            visible: true, 
            duration: 3000, 
            state: 'info'
          });
          return true
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å oppdatere dine favorittbehandlinger!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return false;
    },


    /**--------------------------------------- PRODUCTS  ---------------------------------------------**/

    /**
     * Fetch the user's favorite products
     *
     * @param baseUrl - axios endpoint url
     * @param siteIds - Siteids
     * @returns {FavoriteProduct}
     */
    async GetFavoriteProducts(baseUrl, siteIds) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/favorites/products`, siteIds
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.array.map(emp => new FavoriteProduct(emp));
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å hente dine favorittprodukter!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Updates the user's favorite products
     *
     * @param baseUrl - axios endpoint url
     * @param productId - productId (string)
     * @param siteId - siteId
     * @returns {Boolean}
     */
    async UpdateFavoriteProduct(baseUrl, productId, siteId) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/favorites/products/update`,
          { 
            'productId': productId,
            'siteId': siteId.toString()
          }
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 203) {
          ProfileEventbus.$emit("snackbar", { 
            message: 'Produkter er oppdatert!', 
            visible: true, 
            duration: 3000, 
            state: 'info'
          });
          return true
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å oppdatere dine favorittprodukter!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return false;
    },


    /**--------------------------------------- CUSTOMER PROGRAMS  ---------------------------------------------**/

    /**
     * Fetch customer programs
     *
     * @param baseUrl - axios endpoint url
     * @param chainId - chain id (string)
     * @returns {CustomerProgram}
     */
    async GetCustomerPrograms(baseUrl, chainId) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/my-page/customer/program`, { params: { chainId: chainId }}
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.array.map(pr => new CustomerProgram(pr));
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å hente fordelsprogram!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Fetch customer program by id
     *
     * @param baseUrl - axios endpoint url
     * @param customerProgramId - customer program id
     * @param siteId - Site ID
     * @returns {CustomerProgram}
     */
    async GetCustomerProgramById(baseUrl, customerProgramId, siteId) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/my-page/customer/program/${customerProgramId}/${siteId}`
        ).then(res => {
          result = res
        })
        if (result.data && (result.data.responseCode === 200 || result.data.responseCode == 204)) {
          return new CustomerProgramWithHistory(result.data.dto);
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å hente fordelsprogrammet!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Updates the user's membership programs
     *
     * @param baseUrl - axios endpoint url
     * @returns {Boolean}
     */
    async AddOrRemoveCustomerProgram(baseUrl, customerProgramRequest) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/customer/program/add-or-remove`, customerProgramRequest
        ).then(res => {
          result = res
        })
        if (result.data && result.data.booleanValue) {
          ProfileEventbus.$emit("snackbar", { 
            message: customerProgramRequest.registerCustomerInCustomerProgram ? 'Du har blitt med i fordelsprogrammet!' :'Du har forlatt fordelsprogrammet!', 
            visible: true, 
            duration: 3000, 
            state: 'info'
          });
          return true
        } else {
          ProfileEventbus.$emit("snackbar", { 
            message: customerProgramRequest.registerCustomerInCustomerProgram ? 'Noe gikk galt når du prøvde å bli med i fordelsprogrammet. Prøv igjen!' :'Noe gikk galt når du forsøkte å melde deg ut av fordelsprogrammet. Prøv igjen!', 
            visible: true, 
            duration: 3000, 
            state: 'error'
          });
        }
      } catch (e) {
        
      }
      return false;
    },


    /**--------------------------------------- Orders  ---------------------------------------------**/
    /**
     * Fetch product orders
     *
     * @param baseUrl - axios endpoint url
     * @param siteIds - siteIds (Array)
     * @returns {ProductOrder[]}
     */
    async GetUserOrderHistory(baseUrl, siteIds) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/FixitPortalOrder/get-user-orders-history-by-site-ids`, siteIds
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.result.map(x => {return new ProductOrder(x)})
        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi forsøkte å hente din ordehistorikk!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
        return []
      }
    },
    /**
     * Fetch product order details
     *
     * @param baseUrl - axios endpoint url
     * @param orderId - orderId (Int)
     * @returns {ProductOrderDetailed[]}
     */
    async GetOrderDetails(baseUrl, orderId) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/OrderHistory/get-order-details/${orderId}`
        ).then(res => {
          result = res

        })
        if (result.data && result.data.responseCode === 200) {
          return new ProductOrderDetailed(result.data.dto)

        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi forsøkte å hente ordre detaljer!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
        return []
      }
    },
    /**
     * Fetch appointments
     *
     * @param baseUrl - axios endpoint url
     * @param chainId - chain id (string)
     * @param siteIds - siteIds (Array)
     * @returns {Order[]}
     */
    async GetUserAppointments(baseUrl, siteIds) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/appointments`, siteIds
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.dto.map(x => new Order(x))
        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi forsøkte å hente din ordehistorikk!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Fetch appointment by id
     *
     * @param baseUrl - axios endpoint url
     * @param siteId - siteId
     * @param appointmentId - appointment id
     * @param type - order history type
     * @returns {Array}
     */
    async GetAppointmentById(baseUrl, siteId, appointmentId, type) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/my-page/${type === 4 ? 'noShow' : 'appointment'}/${siteId}/${appointmentId}`
        ).then(res => {
          result = res
        })
        if (result.data && (result.data.responseCode === 200)) {
          return new OrderDetailed(result.data.dto);
        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi forsøkte å hente ordren!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Cancel appointment by id
     *
     * @param baseUrl - axios endpoint url
     * @param siteId - siteId
     * @param appointmentId - appointment id
     * @param isTpn - isTpn bool
     * @returns {Array}
     */
    async CancelAppointment(baseUrl, siteId, isTpn, appointmentId) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/appointment/cancel-appointment`, 
          {
            'siteId': siteId,
            'istpn': isTpn,
            'appointmentId': appointmentId
          }
        ).then(res => {
          result = res
        })
        if (result.data && (result.data.responseCode === 703 || result.data.responseCode == 200 || result.data.responseCode == 202)) {
          ProfileEventbus.$emit("snackbar", { 
            message: 'Din time er avbestilt.',
            visible: true, 
            duration: 3000, 
            state: 'info'
          });
          return true;
        } else {
          ProfileEventbus.$emit("error", { 
            message: 'Noe gikk galt når vi forsøkte å avbestille timen!', 
            visible: true, 
            duration: 3000, 
            state: 'error'
          });
          return false
        }
      } catch (e) {
      }
    },
    /**
     * Fetch receipt by orderId
     *
     * @param baseUrl - axios endpoint url
     * @param orderId - orderId
     * @returns {file}
     */
    async GetReceiptById(baseUrl, orderId) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/FixitPortalOrder/get-invoice-pdf?orderId=${orderId}`, 
          {
            responseType: 'blob'
          }
        ).then(res => {
          result = res
        })
        if (result.data && (result.status === 200)) {
          return result.data
        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi forsøkte å hente kvitteringen!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**--------------------------------------- CONSENTS  ---------------------------------------------**/

    /**
     * Fetch the user's consents
     *
     * @param baseUrl - axios endpoint url
     * @param chainId - axios endpoint url
     * @returns {Object}
     */
    async GetUserConsents(baseUrl, chainId) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/my-page/consents/get-user-consents?chainId=${chainId}`
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.dto;
        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi forsøkte å hente dine samtykker!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Update the OnlineSluttKunde user's consent
     *
     * @param baseUrl - axios endpoint url
     * @returns {Object}
     */
    async UpdateOnlineSluttKundeConsents(baseUrl, params, chainId, reuseSelection) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/consents/update-onlinesluttkunde-consents`, params, chainId, reuseSelection
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          ProfileEventbus.$emit("snackbar", { 
            message: 'Samtykker oppdatert!', 
            visible: true, 
            duration: 3000, 
            state: 'info'
          });
          return result.data.dto;
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å oppdatere dine samtykker!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    /**
     * Update the customer user's consent
     *
     * @param baseUrl - axios endpoint url
     * @returns {Object}
     */
    async UpdateCustomerConsents(baseUrl, params, chainId, reuseSelection) {
      let result;
      try {
        await _axios.post(
          baseUrl + `/api/my-page/consents/update-customer-consents?chainId=${chainId}&reuseSelection=${reuseSelection}`, params
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          ProfileEventbus.$emit("snackbar", { 
            message: 'Samtykker oppdatert!', 
            visible: true, 
            duration: 3000, 
            state: 'info'
          });
          return result.data.dto;
        }
      } catch (e) {
        ProfileEventbus.$emit("snackbar", { 
          message: 'Noe gikk galt når vi forsøkte å oppdatere dine samtykker!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },
    /**
     * @param baseUrl - axios endpoint url
     * @returns {Object}
     */
    async GetDefaultPaymentMethod(baseUrl) {
      let result;
      try {
        await _axios.get(
          baseUrl + '/api/my-page/default-payment-option'
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data.dto;
        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },
    /**
     * @param baseUrl - axios endpoint url
     * @returns {Object}
     */
    async UpdateDefaultPaymentMethod(baseUrl, paymentType) {
      let result;
      try {
        await _axios.patch(
          baseUrl + '/api/my-page/default-payment-option/update', {paymentOption: paymentType}
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 201) {
          return result.data.dto;
        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },

    async GetPaymentToken() {
      return await _axios
        .get(process.env.VUE_APP_FIXIT_NO_BOOKING_URL + '/api/Payment/tokens')
        .then((res) => {
          if (res.data.responseCode === 200) {
            return res.data.dto.length
              ? res.data.dto[0]
              : {};
          } else {
            return false;
          }
        });
    },
    async CreatePaymentToken() {
      return await _axios
        .post(
          process.env.VUE_APP_FIXIT_NO_BOOKING_URL +
            `/api/Payment/create-payment-token?returnUrl=${
              process.env.VUE_APP_CHECKOUT_WINDOW_URL +
              '?parent_url=' +
              process.env.VUE_APP_FIXIT_PROFILE_URL
            }`
        )
        .then((res) => {
          if (res.data.responseCode === 200) {
            return res.data.dto;
          } else {
            return '';
          }
        })
        .catch(function (err) {
          return '';
        });
    },
    async DeletePaymentToken(tokenId) {
      return await _axios
        .delete(
          process.env.VUE_APP_FIXIT_NO_BOOKING_URL +
            `/api/Payment/tokens/${tokenId}/delete`
        )
        .then((res) => {
          if (res.data.responseCode === 200) {
            return res.data.dto.length
              ? res.data.dto[0]
              : {};
          } else {
            return false;
          }
        })
        .catch(function (err) {
          return false;
        });
    },
    /**
     * Cancel a product order
     *
     * @param baseUrl - axios endpoint url
     */
    async CancelOrder(baseUrl, orderId) {
      let result;
      try {
        await _axios.put(
          baseUrl + `/api/FixitPortalOrder/cancel-order?orderId=${orderId}`
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return true;
        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi skulle kansellere ordren.', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },
    /**
     * Validate postalCode
     *
     * @param baseUrl - axios endpoint url
     * @param postalCode - int
     * @returns {Object}
     */
    async ValidatePostalCode(baseUrl, postalCode) {
      let result;
      try {
        await _axios.get(
          baseUrl + `/api/Order/get-postal-codes?searchValue=${postalCode}`
        ).then(res => {
          result = res
        })
        if (result.data && result.data.responseCode === 200) {
          return result.data;
        }
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi skulle verifisere postnummeret ditt!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return [];
    },
    async RepeatOrder(repeatOrderRequest) {
      try {
        return await _axios
          .post(process.env.VUE_APP_FIXIT_NO_BOOKING_URL + '/api/OrderHistory/repeat-order', repeatOrderRequest)
          .then((res) => {
            if (res.data.responseCode === 200) {
              return res.data.cart
            } else {
              return false;
            }
          });
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi forsøkte å gjenta bestillingen!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return false
    },
    async SendReview(ratingsRequest) {
      try {
        return await _axios
          .post(process.env.VUE_APP_FIXIT_NO_BOOKING_URL + '/api/Salon/add-rating-to-salon', ratingsRequest)
          .then((res) => { return res.data.responseCode === 200 });
      } catch (e) {
        ProfileEventbus.$emit("error", { 
          message: 'Noe gikk galt når vi forsøkte å sende vurderingen!', 
          visible: true, 
          duration: 3000, 
          state: 'error'
        });
      }
      return false
    },
    
  };

  
  return ProfileSvc;
}
